<template>
    <div>
        <h5 v-if="root_comment" class="mt-4">Join in on the conversation</h5>
        <div class="card-text mb-3 text-right" v-if="(! deleted) && (! posted)">
            <small v-if="owner" v-on:click="deleteComment()" class="text-muted pointer">Delete |</small>
            <small v-on:click="replying = true" v-show="!replying" class="text-muted pointer">Reply</small>
            <small v-on:click="replying = false" v-show="replying" class="text-muted pointer">Close Reply</small>
            <div class="reply-form-container" v-if="replying">
                <textarea name="body" class="form-control mb-2" v-model="body"></textarea>
                <button type="submit" class="btn btn-outline-primary" :disabled="!body" @click="saveComment">Submit Comment</button>
            </div>
        </div>
        <div class="alert alert-success" role="alert" v-if="posted">
            Comment Successfully Posted!
        </div>
        <div class="card mb-3" v-if="posted">
            <div class="card-body pb-0">
                <div class="comment-info d-block">
                    <b>{{ username }}</b> 
                </div>
                <p>{{ body }}</p>
            </div>
        </div>
        <div class="alert alert-warning" role="alert" v-if="deleted">
            Comment Deleted.
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            comment : null,
            type: null,
            owner: null,
            username: null,
            root_comment: false,
        },
        data() {
            return  {
                replying: false,
                body: '',
                posted: false,
                deleted: false,
            }       
        },
        http: {
            root: '/root',
            headers: {
                'X-CSRF-Token': Laravel.csrfToken
            }
        },
        created()
        {
            if(this.root_comment)
            {
                this.replying = true;
            }
        },
        methods: {
            saveComment()
            {
                var $data = {
                    'type':     this.type,
                    'id' :      AppCreds.identifier,
                    'parentId': this.comment,
                    'body' :    this.body,
                }
                this.$http.post('/ajax/comment/store', $data).then(response => {
                    this.posted = true;
                  }, response => {
                    // error callback
                  });
            },
            deleteComment()
            {
                var $data = {
                    'id' :      this.comment,
                }
                this.$http.post('/ajax/comment/delete', $data).then(response => {
                    this.deleted = true;
                  }, response => {
                    // error callback
                  });
            }
        }
    }
</script>
